// What a draft holds, read the way the template switch needs it. A draft is the object a panel's Save hands over (or its
// onValuesChange reports) once the host has mapped it: params, headerParams, mediaUrl, location, buttonUrlParam,
// ctaButtonUrl, waTemplateJson. Pure; see ../README.md.
import { DOUBLE_BRACE_RE, isFilled } from './validators';
import { isObject, wireJsonHoldsValue } from './savedJsonMatch';

const filled = (list) => Array.isArray(list) && list.some(isFilled);

/**
 * Whether a draft holds anything the marketer typed. A blank form reports every slot empty and its wire JSON in shape, so
 * neither counts. The host uses it to tell a template's own earlier input from a visit that left it empty.
 * @param {object} [draft]
 * @returns {boolean}
 */
export function draftHasValue(draft) {
  return filled(draft?.params) || filled(draft?.headerParams) || isFilled(draft?.mediaUrl) || isFilled(draft?.buttonUrlParam)
    || isFilled(draft?.ctaButtonUrl) || (isObject(draft?.location) && Object.values(draft.location).some(isFilled))
    || wireJsonHoldsValue(draft?.waTemplateJson);
}

/**
 * The single dynamic button's value, whichever of the two fields the draft kept it in: the suffix of a DYNAMIC button
 * (buttonUrlParam) or the full URL of a DYNAMIC_LINK_TRACK one (ctaButtonUrl).
 * @param {object} [draft]
 * @returns {string}
 */
export const dynamicButtonValue = (draft) => draft?.buttonUrlParam || draft?.ctaButtonUrl || '';

/**
 * Whether any text in a draft or a prefill still holds a double brace, by the rule the panels refuse on Save
 * (DOUBLE_BRACE_RE). Reads nested objects and lists too, so it sees button values and carousel cards in wire JSON.
 * @param {*} value
 * @returns {boolean}
 */
export function draftHasDoubleBrace(value) {
  if (typeof value === 'string') return DOUBLE_BRACE_RE.test(value);
  if (Array.isArray(value)) return value.some(draftHasDoubleBrace);
  return isObject(value) && Object.values(value).some(draftHasDoubleBrace);
}
